(function($, window, document, undefined) {

  var Materialize = window.Materialize || {};

  // Function to update labels of text fields
  Materialize.updateTextFields = function() {
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';
    $(input_selector).each(function(index, element) {
      if ($(element).val().length > 0 || element.autofocus ||$(this).attr('placeholder') !== undefined || $(element)[0].validity.badInput === true) {
        $(this).siblings('label').addClass('active');
      }
      else {
        $(this).siblings('label').removeClass('active');
      }
    });
  };

  // Text based inputs
  var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';

  // Add active if form auto complete
  $(document).on('change', input_selector, function() {
    if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
      $(this).siblings('label').addClass('active');
    }
    window.validate_field($(this));
  });

  // Add active if input element has been pre-populated on document ready
  $(document).ready(function() {
    Materialize.updateTextFields();
  });

  // HTML DOM FORM RESET handling
  $(document).on('reset', function(e) {
    var formReset = $(e.target);
    if (formReset.is('form')) {
      formReset.find(input_selector).removeClass('valid').removeClass('invalid');
      formReset.find(input_selector).each(function() {
        if ($(this).attr('value') === '') {
          $(this).siblings('label').removeClass('active');
        }
      });

      // Reset select
      formReset.find('select.initialized').each(function() {
        var reset_text = formReset.find('option[selected]').text();
        formReset.siblings('input.select-dropdown').val(reset_text);
      });
    }
  });

  // Add active when element has focus
  $(document).on('focus', input_selector, function() {
    $(this).siblings('label, .prefix').addClass('active');
  });

  $(document).on('blur', input_selector, function() {
    var $inputElement = $(this);
    var selector = ".prefix";

    if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === undefined) {
      selector += ", label";
    }

    $inputElement.siblings(selector).removeClass('active');

    window.validate_field($inputElement);
  });

  window.validate_field = function(object) {
    var hasLength = object.attr('length') !== undefined;
    var lenAttr = parseInt(object.attr('length'));
    var len = object.val().length;

    if (object.val().length === 0 && object[0].validity.badInput === false) {
      if (object.hasClass('validate')) {
        object.removeClass('valid');
        object.removeClass('invalid');
      }
    } else {
      if (object.hasClass('validate')) {
        // Check for character counter attributes
        if ((object.is(':valid') && hasLength && (len <= lenAttr)) || (object.is(':valid') && !hasLength)) {
          object.removeClass('invalid');
          object.addClass('valid');
        } else {
          object.removeClass('valid');
          object.addClass('invalid');
        }
      }
    }
  };

})(jQuery, window, document);
